module.exports = __webpack_public_path__ + "static/media/b-arts-major-1_LR.d1547c44.jpg";